import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { UserIdSchema } from "@/schemas/user-schema";
import { getLocalStorageJson } from "./local-storage";

export const guardGetUserFromLocalStorage = () => {
  const user = getLocalStorageJson(LocalStorageKeys.USER_KEY);
  if (!user) {
    throw new Error("User not found");
  }
  return UserIdSchema.parse(user);
};
